import React, { FC } from 'react';
import { ActionCardListT } from './types';

import { ActionCardList as Organism } from '@components/Organisms';

export const ActionCardList: FC<ActionCardListT> = ({ heading, actionCards, display }) => {
  return <Organism heading={heading} actionCards={actionCards} display={display} />;
};
